/** Demo route inventory for marketing pages (corridor pages, etc.). */

export type HostedRide = {
    id: string;
    from: string;
    to: string;
    date: string;
    time: string;
    seatsAvailable: number;
    pricePerSeat: number;
    vehicleType: string;
    rating: number;
  };
  
  export type WaitingGuest = {
    id: string;
    from: string;
    to: string;
  };
  
  export const hostedRides: HostedRide[] = [
    {
      id: "hyd-vja-1",
      from: "Hyderabad",
      to: "Vijayawada",
      date: "2026-05-06",
      time: "16:30",
      seatsAvailable: 2,
      pricePerSeat: 720,
      vehicleType: "Sedan",
      rating: 4.0,
    },
    {
      id: "hyd-vja-2",
      from: "Hyderabad",
      to: "Vijayawada",
      date: "2026-05-07",
      time: "07:00",
      seatsAvailable: 1,
      pricePerSeat: 923,
      vehicleType: "Mini SUV",
      rating: 4.9,
    },
    {
      id: "hyd-vja-3",
      from: "Hyderabad",
      to: "Vijayawada",
      date: "2026-05-06",
      time: "19:15",
      seatsAvailable: 3,
      pricePerSeat: 650,
      vehicleType: "Sedan",
      rating: 4.3,
    },
    {
      id: "hyd-vja-4",
      from: "Hyderabad",
      to: "Vijayawada",
      date: "2026-05-08",
      time: "06:00",
      seatsAvailable: 2,
      pricePerSeat: 780,
      vehicleType: "Hatchback",
      rating: 4.6,
    },
    {
      id: "hyd-vja-5",
      from: "Hyderabad",
      to: "Vijayawada",
      date: "2026-05-09",
      time: "14:00",
      seatsAvailable: 1,
      pricePerSeat: 890,
      vehicleType: "SUV",
      rating: 4.8,
    },
    {
      id: "hyd-vja-6",
      from: "Hyderabad",
      to: "Vijayawada",
      date: "2026-05-10",
      time: "10:30",
      seatsAvailable: 2,
      pricePerSeat: 699,
      vehicleType: "Sedan",
      rating: 4.5,
    },
    {
      id: "hyd-vja-7",
      from: "Hyderabad",
      to: "Vijayawada",
      date: "2026-05-11",
      time: "18:00",
      seatsAvailable: 4,
      pricePerSeat: 550,
      vehicleType: "Mini SUV",
      rating: 4.2,
    },
    {
      id: "vja-hyd-1",
      from: "Vijayawada",
      to: "Hyderabad",
      date: "2026-05-06",
      time: "18:00",
      seatsAvailable: 1,
      pricePerSeat: 810,
      vehicleType: "Mini SUV",
      rating: 4.4,
    },
    {
      id: "vja-hyd-2",
      from: "Vijayawada",
      to: "Hyderabad",
      date: "2026-05-07",
      time: "05:30",
      seatsAvailable: 2,
      pricePerSeat: 745,
      vehicleType: "Sedan",
      rating: 4.7,
    },
    {
      id: "vja-hyd-3",
      from: "Vijayawada",
      to: "Hyderabad",
      date: "2026-05-08",
      time: "20:00",
      seatsAvailable: 3,
      pricePerSeat: 680,
      vehicleType: "Hatchback",
      rating: 4.5,
    },
    {
      id: "vja-hyd-4",
      from: "Vijayawada",
      to: "Hyderabad",
      date: "2026-05-09",
      time: "06:45",
      seatsAvailable: 2,
      pricePerSeat: 799,
      vehicleType: "Sedan",
      rating: 4.6,
    },
    {
      id: "vja-hyd-5",
      from: "Vijayawada",
      to: "Hyderabad",
      date: "2026-05-10",
      time: "15:30",
      seatsAvailable: 1,
      pricePerSeat: 850,
      vehicleType: "SUV",
      rating: 4.8,
    },
    {
      id: "vja-hyd-6",
      from: "Vijayawada",
      to: "Hyderabad",
      date: "2026-05-11",
      time: "07:15",
      seatsAvailable: 2,
      pricePerSeat: 710,
      vehicleType: "Sedan",
      rating: 4.3,
    },
  ];
  
  export const waitingGuests: WaitingGuest[] = [
    { id: "wg-hyd-vja-1", from: "Hyderabad", to: "Vijayawada" },
    { id: "wg-hyd-vja-2", from: "Hyderabad", to: "Vijayawada" },
    { id: "wg-vja-hyd-1", from: "Vijayawada", to: "Hyderabad" },
  ];
  